'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable import/prefer-default-export */

var ColorUtil = exports.ColorUtil = function ColorUtil() {
  _classCallCheck(this, ColorUtil);
};

ColorUtil.isColorDark = function () {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rgb(0, 0, 0)';

  var rgb = [];
  var r = 0;
  var g = 0;
  var b = 0;

  if (color.match(/^rgb/)) {
    rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    r = rgb[1];
    g = rgb[2];
    b = rgb[3];
  } else {
    rgb = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
    r = rgb >> 16;
    g = rgb >> 8 & 255;
    b = rgb & 255;
  }

  var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  return hsp > 127.5;
};